import angular from 'angular';
import RadioComponent from './radio.component';

const RadioModule = angular
    .module('control-room.commons.form.components.radio', [])
    .component('crRadio', RadioComponent);

export default RadioModule;
